import { Component, Input } from '@angular/core';

import { SpinnerType } from '../../interfaces';

@Component({
  selector: 'fin-spinner',
  styleUrls: ['./spinner.component.scss'],
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent {
  public readonly SpinnerType = SpinnerType;

  @Input()
  type: SpinnerType = SpinnerType.ROUND_ARROW;

  @Input()
  classes = '';
}
